import { TbPackageOff } from "react-icons/tb";

const NoDataFound = ({ message = "No items found" }) => {
  return (
    <div className="text-center text-[#265fc9] py-10 my-5">
      <TbPackageOff className="mx-auto w-32 h-32 mb-4 text-backgroundColor animate-pulse" />
      <h3 className="text-lg font-semibold">{message}</h3>
    </div>
  );
};

export default NoDataFound;